import {sygnet} from './sygnet'
import {logo} from './logo'
import {logoNegative} from './logo-negative'
import {logoVolvero} from './logo-volvero'

import {
    cilApplicationsSettings,
    cilSpeedometer,
    cilSun,
    cilMoon,
    cilUser,
    cilLockLocked,
    cilAccountLogout,
    cilPlus,
    cilUserPlus,
    cilEnvelopeClosed,
    cilPhone,
    cilBuilding,
    cilCheck,
    cilCheckCircle,
    cilXCircle,
    cilX,
    cilGroup,
    cilAddressBook,
    cilDescription,
    cilNotes,
    cilFile,
    cilCarAlt,
    cilCalendar,
    cilCalendarCheck,
    cilCreditCard,
    cilCog,
    cilTrash,
    cilShieldAlt,
    cilLocationPin,
    cilBarcode,
    cilShortText,
    cilImage,
    cilClock,
    cilMoney,
    cilLibrary,
    cilTag,
    cilChatBubble
} from '@coreui/icons'

export const icons = Object.assign({}, {
    sygnet,
    logo,
    logoNegative,
    logoVolvero,
}, {
    cilApplicationsSettings,
    cilSpeedometer,
    cilSun,
    cilMoon,
    cilUser,
    cilLockLocked,
    cilAccountLogout,
    cilPlus,
    cilUserPlus,
    cilEnvelopeClosed,
    cilPhone,
    cilBuilding,
    cilCheck,
    cilCheckCircle,
    cilXCircle,
    cilX,
    cilGroup,
    cilAddressBook,
    cilDescription,
    cilNotes,
    cilFile,
    cilCarAlt,
    cilCalendar,
    cilCalendarCheck,
    cilCreditCard,
    cilCog,
    cilTrash,
    cilShieldAlt,
    cilLocationPin,
    cilBarcode,
    cilShortText,
    cilImage,
    cilClock,
    cilMoney,
    cilLibrary,
    cilTag,
    cilChatBubble
})
